// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vu-8";
export var editMode = "_vu-3";
export var headerRow = "_vu-a";
export var headerTitle = "_vu-b";
export var product = "_vu-1";
export var productDetails = "_vu-5";
export var productDivider = "_vu-7";
export var productImage = "_vu-2";
export var productInfo = "_vu-4";
export var productTitle = "_vu-6";
export var strikethrough = "_vu-9";
export var upsellProductsCard = "_vu-0";